import { render, staticRenderFns } from "./PeersExperience.vue?vue&type=template&id=8ecffa32&scoped=true"
import script from "./PeersExperience.vue?vue&type=script&lang=js"
export * from "./PeersExperience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecffa32",
  null
  
)

export default component.exports